"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultGetOptionInfo = exports.defaultGetOptionIconInfo = exports.LATEST_HELPER_OPTION = exports.EMPTY_VALUE = exports.EMPTY_MULTIPLE_VALUE = exports.DEFAULT_SELECT_DISPLAY_PROPS = exports.DEFAULT_OPTIONS = void 0;
var _constants = require("../SelectDropdown/constants");
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EMPTY_MULTIPLE_VALUE = exports.EMPTY_MULTIPLE_VALUE = [];
var EMPTY_VALUE = exports.EMPTY_VALUE = '';
var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = [];
var DEFAULT_SELECT_DISPLAY_PROPS = exports.DEFAULT_SELECT_DISPLAY_PROPS = {};
var LATEST_HELPER_OPTION = exports.LATEST_HELPER_OPTION = {
  id: -3,
  name: 'Latest',
  type: _constants.TYPE_SUBTITLE,
  withDivider: false,
  tooltip: 'Displaying the latest 100 values. Use the search to find specific items.'
};
var defaultGetOptionInfo = exports.defaultGetOptionInfo = function defaultGetOptionInfo(_ref) {
  var hint = _ref.hint,
    warnings = _ref.warnings,
    errors = _ref.errors;
  var info = null;
  if (errors !== null && errors !== void 0 && errors.length) {
    info = _objectSpread(_objectSpread({}, info), {}, {
      errors: errors
    });
  }
  if (warnings !== null && warnings !== void 0 && warnings.length) {
    info = _objectSpread(_objectSpread({}, info), {}, {
      warnings: warnings
    });
  }
  if (hint) {
    info = _objectSpread(_objectSpread({}, info), {}, {
      hint: hint
    });
  }
  return info;
};
var defaultGetOptionIconInfo = exports.defaultGetOptionIconInfo = function defaultGetOptionIconInfo(_ref2) {
  var hint = _ref2.hint,
    warnings = _ref2.warnings,
    errors = _ref2.errors;
  return errors !== null && errors !== void 0 && errors.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ErrorOutlineIcon, {
    sx: {
      fontSize: 16
    },
    color: 'error'
  }) : warnings !== null && warnings !== void 0 && warnings.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.WarningAmberIcon, {
    sx: {
      fontSize: 16
    },
    color: 'warning'
  }) : hint ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.HelpOutlineIcon, {
    sx: {
      fontSize: 16
    }
  }) : null;
};